/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */

import React from 'react';
import { View, ScrollView, TouchableOpacity } from 'react-native';
import PropTypes from 'prop-types';

import ModalHalf from '@components/modal/ModalHalf';
import SociollaText from '@components/sociolla/SociollaText';
import Image from '@components/global/Image';
import Button from '@components/form/Button';
import Colors from '@global/colors';
import { isWeb } from '@global/screens';

const ModalProductExist = (props) => {
  const { show, onClose, products, onRemoveProduct, onNavigateDetail } = props;

  const renderProductItem = (item, index) => {
    const attributes = item.combination?.attributes || {};
    const variantText = Object.keys(attributes)
      .map((key) => {
        const attr = attributes[key];
        const name = attr.name || '';
        return `${key.charAt(0).toUpperCase() + key.slice(1)}: ${name}`;
      })
      .join(', ');

    return (
      <View
        key={index}
        style={{
          flexDirection: 'row',
          padding: 15,
          borderWidth: 1,
          borderColor: '#E0E0E0',
          borderRadius: 5,
          marginBottom: 10,
          backgroundColor: '#fff',
        }}>
        <View style={{ marginRight: 15 }}>
          <Image
            source={{ uri: item.combination?.image || '' }}
            style={{ width: 60, height: 60, borderRadius: 5 }}
            resizeMode="contain"
          />
        </View>
        <View style={{ flex: 1, justifyContent: 'space-between' }}>
          <View>
            <SociollaText type="bold" style={{ fontSize: 12, marginBottom: 4 }}>
              {item.brand?.name?.toUpperCase()}
            </SociollaText>
            <SociollaText
              style={{ fontSize: 13, marginBottom: 4, color: Colors.grey1 }}>
              {item.name}
            </SociollaText>
            {variantText ? (
              <SociollaText style={{ fontSize: 12, color: Colors.grey2 }}>
                {variantText}
              </SociollaText>
            ) : null}
          </View>
        </View>
        <View
          style={{
            alignItems: 'flex-end',
            justifyContent: 'space-between',
            marginLeft: 10,
          }}>
          <TouchableOpacity
            onPress={() => {
              const requestId =
                item.request_product?.id || item.request_product?._id;
              if (isWeb) {
                window.open(
                  `/request-product/request-products/detail/${requestId}`,
                  '_blank',
                );
              } else {
                onNavigateDetail(requestId);
              }
            }}>
            <SociollaText
              type="bold"
              style={{
                fontSize: 12,
                color: Colors.blue10,
                textDecorationLine: 'underline',
              }}>
              {item.request_product?.reference_code}
            </SociollaText>
          </TouchableOpacity>

          <TouchableOpacity
            style={{ flexDirection: 'row', alignItems: 'center' }}
            onPress={() => onRemoveProduct(item)}>
            <Image
              source={require('@assets/img/icons/trash-grey.svg')}
              svg={true}
              style={{
                width: 14,
                height: 14,
                marginRight: 5,
                tintColor: Colors.grey2,
              }}
            />
            <SociollaText style={{ fontSize: 12, color: Colors.grey2 }}>
              Remove Product
            </SociollaText>
          </TouchableOpacity>
        </View>
      </View>
    );
  };

  return (
    <ModalHalf
      visible={show}
      onClose={onClose}
      title="Cannot Create Product Tester Request"
      maxWidth={isWeb ? 600 : '100%'}>
      <View style={{ paddingHorizontal: 20, paddingBottom: 20, width: '100%' }}>
        <SociollaText
          style={{ fontSize: 14, marginBottom: 15, color: Colors.grey1 }}>
          The following Product Tester requests already exist and require
          delivery confirmation:
        </SociollaText>

        <ScrollView style={{ maxHeight: 300, marginBottom: 15 }}>
          {products.map((item, index) => renderProductItem(item, index))}
        </ScrollView>

        <SociollaText
          style={{ fontSize: 14, marginBottom: 20, color: Colors.grey1 }}>
          Please complete the delivery confirmation for each product before
          creating a new request.
        </SociollaText>

        <Button
          type="primary"
          title="OK"
          onPress={onClose}
          buttonStyle={{ width: '100%' }}
        />
      </View>
    </ModalHalf>
  );
};

ModalProductExist.propTypes = {
  show: PropTypes.bool,
  onClose: PropTypes.func,
  products: PropTypes.array,
  onRemoveProduct: PropTypes.func,
  onNavigateDetail: PropTypes.func,
};

export default ModalProductExist;
